import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { SALES_PERSON_REPORT_ID } from './salesPersonReportId';

const emptyColumns = [FIELDS.SALES_PERSON].map(createFooterMapper(SALES_PERSON_REPORT_ID));

const reportFooterColumnDefinition = [...emptyColumns];

export default reportFooterColumnDefinition;
